import { Box, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { ReactComponent as PersonIcon } from "../Assets/svg/PersonIcon.svg";
import { ReactComponent as AppSearchIcon } from "../Assets/svg/AppSearchIcon.svg";
import { ReactComponent as AddPerson } from "../Assets/svg/AddPerson.svg";
import { ReactComponent as PayeshLogo } from "../Assets/svg/PayeshLogo.svg";
import { ReactComponent as TaghazaIcon } from "../Assets/svg/TaghazaIcon.svg";
import { ReactComponent as NamayeIcon } from "../Assets/svg/NamayeIcon.svg";
import { ReactComponent as Logo } from "../Assets/svg/Logo.svg";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useUserStore } from "../store/user";
import { CheckPermissions } from "./CheckPermissions";
import { useSnackbar } from 'notistack';
import { useSearchPropStore } from "../store/searchProperty";

function ButtonNavigation() {
    const navigate = useNavigate();

    const location = useLocation()

    console.log("location", location)

    const { enqueueSnackbar } = useSnackbar();

    const userInfo = useUserStore((state) => state.userInfo)

    const emptySearchData = useSearchPropStore((state) => state.emptySearchData)


    const handleNavigation = (rout, permission) => {
        if (CheckPermissions(userInfo, permission))
            navigate(rout)
        else {
            const variant = 'error'
            enqueueSnackbar('شما به این بخش دسترسی ندارد.', { variant });
        }
    }
    return (
        <Box className="button-navigation gray-box rounded-20-top" sx={{ p: '10px', display: "flex", gap: '10px' }}>
            <List>
                <ListItem disablePadding className={location.pathname == "/" ? "active" : ""} onClick={() => {
                    // emptySearchData()
                    navigate("/")
                }}>
                    <ListItemButton >
                        <ListItemIcon>
                            <Logo width="33.627" height="32.583" />
                        </ListItemIcon>
                        <ListItemText primary="پایش" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding className={location.pathname == "/submit-property" ? "active" : ""} onClick={() => handleNavigation("/submit-property", "property_create")}>
                    <ListItemButton>
                        <ListItemIcon>
                            <TaghazaIcon width="33.627" height="32.583" />
                        </ListItemIcon>
                        <ListItemText primary="ثبت ملک" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding className={location.pathname == "/submit-demand" ? "active" : ""} onClick={() => handleNavigation("/submit-demand","applicant_create")}>
                    <ListItemButton>
                        <ListItemIcon>
                            <AddPerson width="33.627" height="32.583" />
                        </ListItemIcon>
                        <ListItemText primary="ثبت تقاضا" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding className={location.pathname == "/applicant" ? "active" : ""} onClick={() => navigate("/applicant")}>
                    <ListItemButton>
                        <ListItemIcon>
                            <AppSearchIcon width="33.627" height="32.583" />
                        </ListItemIcon>
                        <ListItemText primary="جستجو تقاضا" />
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding className={location.pathname == "/settings" ? "active" : ""} onClick={() => navigate('/settings')}>
                    <ListItemButton>
                        <ListItemIcon>
                            <NamayeIcon width="33.627" height="34.583" />
                        </ListItemIcon>
                        <ListItemText primary="نمایه" />
                    </ListItemButton>
                </ListItem>
            </List>
        </Box>
    );
}

export default ButtonNavigation;